import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, change as changeFieldValue, reduxForm } from 'redux-form';
import FormCadastroEmissaoMdfe from './FormCadastroEmissaoMdfe';
import FormCadastroPercursoMdfe from './FormCadastroPercursoMdfe';
import ModalCadastrarPercursoMdfe from './ModalCadastrarPercursoMdfe';
import FormAdicionarCteMdfe from './FormAdicionarCteMdfe';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import { renderField } from '../../util/arraysUtil';
import salvarEmissaoMdfe from '../../actions/mdfe/salvarEmissaoMdfe';
import buscarOpcoesFiltrosEmissoesMdfe from '../../actions/mdfe/buscarOpcoesFiltrosEmissoesMdfe';
import buscarUsuariosMotorista from '../../actions/usuario/buscarUsuariosMotorista';
import { showSuccessMsg, showAlertMsg } from '../../util/messagesUtil';
import { situacaoTransmissaoMdfe, empresaSeguro } from '../../util/constantsUtil';
import moment from 'moment';
import { gerarHashForString } from '../../util/stringUtil';
import selecionarEmissaoMdfe from '../../actions/mdfe/selecionarEmissaoMdfe';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

function textoEmpresaSeguroPorChave(chave) {
    if (!chave) return '';
    const dados = empresaSeguro[chave];
    return dados ? `${dados.cnpj} ${dados.empresa}` : chave;
}

export class PainelCadastroEmissaoMdfe extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.selecionarDestino = this.selecionarDestino.bind(this);
        this.selecionarOrigem = this.selecionarOrigem.bind(this);
        this.limparCampos = this.limparCampos.bind(this);

        this.state = {
            dataEmissao: null,
            percursoMdfe: [],
            ctesVinculados: [],
            cteSelecionado: null,
            veiculoSelecionado: null,
            motoristaSelecionado: null,
            seguroSelecionado: null,
            veiculosSelecionados: [],
            condutoresSelecionados: [],
            exibeLabelCidade: true,
            abaAtiva: 'EMISSAO_MDFE',
        }
    }

    componentDidMount() {
        const ehEdicao = this.props.emissaoMdfeSelecionada && this.props.emissaoMdfeSelecionada.id;

        if (!ehEdicao) {
            this.limparCampos();
            this.props.changeFieldValue('formularioCadastroMdfe', '', '');
        }

        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarOpcoesFiltrosEmissoesMdfe(this.props.empresaSelecionada.id);
            this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
        }

        if (ehEdicao) {
            this.carregarFormulario();
        } else {
            this.props.changeFieldValue('formularioCadastroMdfe', 'modelo', 58);
            this.props.changeFieldValue('formularioCadastroMdfe', 'dv', 0);
            this.props.changeFieldValue('formularioCadastroMdfe', 'tipoEmitente', '1 - Prestador de serviço de transporte');
            this.props.changeFieldValue('formularioCadastroMdfe', 'modal', 'Rodoviário');
            this.props.changeFieldValue('formularioCadastroMdfe', 'tipoCarga', '05 - Carga Geral');
            this.props.changeFieldValue('formularioCadastroMdfe', 'responsavelSeguro', '1 - Emitente do MDF-e');
        }
    }

    componentDidUpdate(prevProps) {
        const mdfe = this.props.emissaoMdfeSelecionada;
        const veiculos = this.props.veiculos || [];
        const prevVeiculos = prevProps.veiculos || [];

        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id
            && this.props.empresaSelecionada.id !== (prevProps.empresaSelecionada && prevProps.empresaSelecionada.id)) {
            this.props.buscarOpcoesFiltrosEmissoesMdfe(this.props.empresaSelecionada.id);
            this.props.buscarUsuariosMotorista(this.props.empresaSelecionada.id);
        }

        if (veiculos.length && prevVeiculos.length === 0 && mdfe && mdfe.veiculo && mdfe.veiculo.id) {
            const v = veiculos.find(x => String(x.id) === String(mdfe.veiculo.id));
            if (v && v.empresaSeguro) {
                this.props.changeFieldValue('formularioCadastroMdfe', 'empresaSeguroVeiculo',
                    textoEmpresaSeguroPorChave(v.empresaSeguro));
            }
        }
    }

    carregarFormulario() {
        this.props.changeFieldValue('formularioCadastroMdfe', 'modelo', 58);
        this.props.changeFieldValue('formularioCadastroMdfe', 'dv', 0);
        this.props.changeFieldValue('formularioCadastroMdfe', 'tipoEmitente', '1 - Prestador de serviço de transporte');
        this.props.changeFieldValue('formularioCadastroMdfe', 'modal', 'Rodoviário');
        this.props.changeFieldValue('formularioCadastroMdfe', 'tipoCarga', '05 - Carga Geral');
        this.props.changeFieldValue('formularioCadastroMdfe', 'responsavelSeguro', '1 - Emitente do MDF-e');

        const mdfe = this.props.emissaoMdfeSelecionada;

        if (mdfe.cidadeOrigem && mdfe.cidadeOrigem.id) {
            this.props.selecionarOrigem({
                id: mdfe.cidadeOrigem.id,
                nome: mdfe.cidadeOrigem.nome,
                uf: mdfe.cidadeOrigem.uf
            });
        }

        if (mdfe.cidadeDestino && mdfe.cidadeDestino.id) {
            this.props.selecionarDestino({
                id: mdfe.cidadeDestino.id,
                nome: mdfe.cidadeDestino.nome,
                uf: mdfe.cidadeDestino.uf
            });
        }

        if (mdfe.veiculo && mdfe.veiculo.id) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'veiculo', {
                label: mdfe.veiculo.nome,
                value: mdfe.veiculo.id,
            });
            if (mdfe.veiculo.empresaSeguro) {
                this.props.changeFieldValue('formularioCadastroMdfe', 'empresaSeguroVeiculo',
                    textoEmpresaSeguroPorChave(mdfe.veiculo.empresaSeguro));
            }
        }

        if (mdfe.motorista && mdfe.motorista.id != null) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'motorista', {
                label: mdfe.motorista.nome,
                value: mdfe.motorista.id,
            });
        }

        if (mdfe.seguro) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'seguro', {
                label: mdfe.seguro.valor,
                value: mdfe.seguro.chave,
            });
        }
        
        this.props.changeFieldValue('formularioCadastroMdfe', 'apolice', mdfe.apoliceSeguro);
        this.props.changeFieldValue('formularioCadastroMdfe', 'averbacao', mdfe.averbacaoSeguro);
        this.props.changeFieldValue('formularioCadastroMdfe', 'cnpjAutorizadoBaixarXml', mdfe.cnpjAutorizadoBaixarXml);

        let percursos = [];
        if (mdfe.percursoMDFeDto) {
            percursos = mdfe.percursoMDFeDto.map(it => ({
                hash: gerarHashForString(`${it.uf}`),
                ...it
            }));
        }

        let ctes = []
        if (mdfe.cteVinculadoDto) {        
            ctes = mdfe.cteVinculadoDto.map(it => {
                return {
                    pedidoId: it.pedidoId,
                    encomenda: it.encomendaId,
                    origem: it.origem,
                    destino: it.destino,
                    chaveCte: it.chaveCte
                }
            })
        }

        this.setState({
            dataEmissao: mdfe.dataEmissao ? moment(mdfe.dataEmissao).toDate() : null,
            percursoMdfe: percursos,
            ctesVinculados: ctes
        });

        if (mdfe.dataEmissao) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'horaEmissao', moment(mdfe.dataEmissao).format('HH:mm'));
            this.props.changeFieldValue('formularioCadastroMdfe', 'numeroMdfe', mdfe.id);
            this.props.changeFieldValue('formularioCadastroMdfe', 'serie', mdfe.serie);            
        }
    }

    adicionarPercursoMdfe(percurso) {
        if (this.state.percursoMdfe.filter(it => it.hash === percurso.hash).length === 0) {
            const percursos = [...this.state.percursoMdfe];
            percursos.push(percurso);
            this.setState({ percursoMdfe: percursos });
        }
    }

    removerPercursoMdfe(hash) {
        this.setState({
            percursoMdfe: this.state.percursoMdfe.filter(it => it.hash !== hash)
        });
    }

    handleSelecionarCte(e) {
        this.setState({ cteSelecionado: e ? e.value : null });
    }

    adicionarCteVinculado() {
        if (!this.state.cteSelecionado) {
            showAlertMsg('Selecione um CT-e para vincular');
            return;
        }
        const cte = this.state.cteSelecionado;
        if (this.state.ctesVinculados.find(it => it.chaveCte === cte.chaveCte)) {
            showAlertMsg('Este CT-e já foi vinculado');
            return;
        }
        this.setState({
            ctesVinculados: [...this.state.ctesVinculados, cte],
            cteSelecionado: null
        });
        this.props.changeFieldValue('formularioCadastroMdfe', 'cteDisponivel', null);
    }

    removerCteVinculado(chaveCte) {
        this.setState({
            ctesVinculados: this.state.ctesVinculados.filter(it => it.chaveCte !== chaveCte)
        });
    }

    limpaViagens(sentido) {
        if (sentido === 'pesquisaOrigem') this.selecionarOrigem(null);
        if (sentido === 'pesquisaDestino') this.selecionarDestino(null);
    }

    selecionarDestino(destino) {
        this.props.selecionarDestino(destino);
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem);
    }

    handleSelecionarVeiculo(e) {
        this.setState({ veiculoSelecionado: e });
        if (!e || e.value == null) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'empresaSeguroVeiculo', '');
            return;
        }
        const veiculo = (this.props.veiculos || []).find(v => String(v.id) === String(e.value));
        if (!veiculo || !veiculo.empresaSeguro) {
            this.props.changeFieldValue('formularioCadastroMdfe', 'empresaSeguroVeiculo', '');
            return;
        }
        this.props.changeFieldValue('formularioCadastroMdfe', 'empresaSeguroVeiculo',
            textoEmpresaSeguroPorChave(veiculo.empresaSeguro));
        if (veiculo.apolice != null && String(veiculo.apolice).trim() !== '') {
            this.props.changeFieldValue('formularioCadastroMdfe', 'apolice', veiculo.apolice);
        }
    }

    handleAdicionarVeiculo() {
        const v = this.state.veiculoSelecionado;
        if (!v || !v.value) { showAlertMsg('Selecione um veículo para adicionar'); return; }
        if (this.state.veiculosSelecionados.find(it => it.id === v.value)) {
            showAlertMsg('Este veículo já foi adicionado'); return;
        }
        this.setState({
            veiculosSelecionados: [...this.state.veiculosSelecionados, { id: parseInt(v.value, 10), placa: v.label }],
            veiculoSelecionado: null,
        });
        this.props.changeFieldValue('formularioCadastroMdfe', 'veiculo', null);
    }

    handleRemoverVeiculo(id) {
        this.setState({ veiculosSelecionados: this.state.veiculosSelecionados.filter(it => it.id !== id) });
    }

    handleSelecionarMotorista(e) {
        this.setState({ motoristaSelecionado: e });
    }

    handleAdicionarCondutor() {
        const m = this.state.motoristaSelecionado;
        if (!m || !m.value) { showAlertMsg('Selecione um motorista para adicionar'); return; }
        if (this.state.condutoresSelecionados.find(it => it.id === m.value)) {
            showAlertMsg('Este motorista já foi adicionado'); return;
        }
        this.setState({
            condutoresSelecionados: [...this.state.condutoresSelecionados, { id: parseInt(m.value, 10), nome: m.label }],
            motoristaSelecionado: null,
        });
        this.props.changeFieldValue('formularioCadastroMdfe', 'motorista', null);
    }

    handleRemoverCondutor(id) {
        this.setState({ condutoresSelecionados: this.state.condutoresSelecionados.filter(it => it.id !== id) });
    }

    handleSelecionarSeguro(e) {
        this.setState({ seguroSelecionado: e });
    }

    exibirBotaoSalvar() {
        const mdfe = this.props.emissaoMdfeSelecionada;
        return !mdfe.id || (mdfe.ultimoHistoricoEmissaoMdfe == null ||
            (mdfe.ultimoHistoricoEmissaoMdfe != null &&
                mdfe.ultimoHistoricoEmissaoMdfe.situacaotransmissao.chave === situacaoTransmissaoMdfe.erro));
    }

    somenteLeitura() {
        return !this.exibirBotaoSalvar();
    }

    exibirCampoBusca() {
        const mdfe = this.props.emissaoMdfeSelecionada;
        if (mdfe.id && this.state.exibeLabelCidade) {
            return (
                <>
                    <div className="col-12 col-sm-12 col-md-8 mb-8 mt-2" style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <div>
                            <label>Cidade que Carrega:</label>
                            <span className='ml-1'>{mdfe.cidadeOrigem && mdfe.cidadeOrigem.nomeComUf}</span>
                        </div>
                        <div className='ml-4'>
                            <label>Cidade que Descarrega:</label>
                            <span className='ml-1'>{mdfe.cidadeDestino && mdfe.cidadeDestino.nomeComUf}</span>
                        </div>
                        {this.exibirBotaoSalvar() && (
                            <button type="button" className="btn btn-editar ml-2" title='Editar Cidades'
                                onClick={() => this.setState({ exibeLabelCidade: false })}>
                                <i className="material-icons nav-icon">&#xe150;</i>
                            </button>
                        )}
                    </div>
                </>
            )
        }

        return (
            <React.Fragment>
                <div className="col-12 col-sm-5 col-md-5 mb-6 mt-3">
                    <label htmlFor="pesquisaOrigem">Cidade que Carrega:</label>
                    <SelecaoCidadeAutocomplete
                        limparViagens={this.limpaViagens.bind(this)}
                        name='pesquisaOrigem'
                        selecionarCidade={this.selecionarOrigem}
                        value={this.props.origem}
                        ehVenda={true}
                    />
                </div>
                <div className="col-12 col-sm-5 col-md-5 mb-6 mt-3">
                    <label htmlFor="pesquisaDestino">Cidade que Descarrega:</label>
                    <SelecaoCidadeAutocomplete
                        name='pesquisaDestino'
                        limparViagens={this.limpaViagens.bind(this)}
                        selecionarCidade={this.selecionarDestino}
                        value={this.props.destino}
                        ehVenda={true}
                    />
                </div>
                {mdfe.id && (
                    <div className="col-12 col-sm-2 col-md-2 mb-6 mt-3"
                        onClick={() => this.setState({ exibeLabelCidade: true })}>
                        <i className="material-icons float-right" style={{ cursor: 'pointer' }}>clear</i>
                    </div>
                )}
                <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12" />
                <Field name="destino" type="hidden" component={renderField} css="form-control col-md-12" />
            </React.Fragment>
        )
    }

    montarParametros(values) {
        let cidadeOrigemId;
        let cidadeDestinoId;
        const mdfe = this.props.emissaoMdfeSelecionada;

        if (this.props.origem && this.props.origem.id && this.props.destino && this.props.destino.id) {
            cidadeOrigemId = this.props.origem.id;
            cidadeDestinoId = this.props.destino.id;
        }

        if (mdfe.id && this.state.exibeLabelCidade) {
            cidadeOrigemId = mdfe.cidadeOrigem.id;
            cidadeDestinoId = mdfe.cidadeDestino.id;
        }

        const veiculoIdRaw = (this.state.veiculoSelecionado && this.state.veiculoSelecionado.value)
            ? this.state.veiculoSelecionado.value
            : (mdfe.veiculo && mdfe.veiculo.id);

        const veiculoCompleto = (this.props.veiculos || []).find(v => String(v.id) === String(veiculoIdRaw));
        const seguroChave = (veiculoCompleto && veiculoCompleto.empresaSeguro)
            || (mdfe.veiculo && mdfe.veiculo.empresaSeguro)
            || null;

        const motoristaIdRaw = (this.state.motoristaSelecionado && this.state.motoristaSelecionado.value)
            ? this.state.motoristaSelecionado.value
            : (mdfe.motorista && (mdfe.motorista.usuarioEmpresaId != null ? mdfe.motorista.usuarioEmpresaId : mdfe.motorista.id));
        
        const percursos = this.state.percursoMdfe.map(p => {
            const ordem = p.ordem;
            const ordemNum = typeof ordem === 'number' ? ordem : (ordem != null && ordem !== '' ? parseInt(String(ordem).trim(), 10) : ordem);
            return {
                uf: p.uf,
                estado: p.estado,
                ordem: Number.isNaN(ordemNum) ? ordem : ordemNum
            };
        });

        const ctesVinculados = (this.state.ctesVinculados || []).map(cte => {
            return {
                pedidoId: cte.pedidoId,
                encomendaId: cte.encomenda,
                origem: cte.origem,
                destino: cte.destino,
                chaveCte: cte.chaveCte
            };
        });

        return {
            id: this.props.id,
            usuarioId: this.props.idUsuario,
            empresaId: this.props.empresaSelecionada.id,
            cidadeOrigemId,
            cidadeDestinoId,
            percursos,
            ctesVinculados,
            veiculoId: veiculoIdRaw ? parseInt(veiculoIdRaw, 10) : null,
            motoristaId: motoristaIdRaw ? parseInt(motoristaIdRaw, 10) : null,
            seguro: seguroChave,
            apoliceSeguro: values.apolice != null && values.apolice !== '' ? values.apolice : null,
            averbacaoSeguro: values.averbacao != null && values.averbacao !== '' ? values.averbacao : null,
            cnpjAutorizadoBaixarXml: values.cnpjAutorizadoBaixarXml != null && values.cnpjAutorizadoBaixarXml !== ''
                ? values.cnpjAutorizadoBaixarXml
                : null,
        }
    }

    irParaAba(aba) {
        this.setState({ abaAtiva: aba });
    }

    voltarAba() {
        const { abaAtiva } = this.state;
        if (abaAtiva === 'PERCURSO_MDFE') {
            this.irParaAba('EMISSAO_MDFE');
        } else if (abaAtiva === 'CTES_MDFE') {
            this.irParaAba('PERCURSO_MDFE');
        } else {
            this.props.history.push('/painel-mdfe');
        }
    }

    proximaAba() {
        const { abaAtiva } = this.state;
        if (abaAtiva === 'EMISSAO_MDFE') {
            this.irParaAba('PERCURSO_MDFE');
        } else if (abaAtiva === 'PERCURSO_MDFE') {
            this.irParaAba('CTES_MDFE');
        }
    }

    limparCampos() {
        this.props.selecionarEmissaoMdfe(null);
        this.selecionarOrigem(null);
        this.selecionarDestino(null);
        this.setState({
            dataEmissao: null,
            percursoMdfe: [],
            ctesVinculados: [],
            cteSelecionado: null,
            veiculoSelecionado: null,
            motoristaSelecionado: null,
            seguroSelecionado: null,
            veiculosSelecionados: [],
            condutoresSelecionados: [],
            exibeLabelCidade: true,
            abaAtiva: 'EMISSAO_MDFE',
        });
        this.setState({percursoMdfe: [], ctesVinculados: []});
        this.props.reset('formularioCadastroMdfe');
    }

    submit(values) {
        const parametros = this.montarParametros(values);

        if (!parametros.cidadeOrigemId || !parametros.cidadeDestinoId) {
            showAlertMsg('É necessário informar a cidade que carrega e a cidade que descarrega');
            return;
        }
        if (!parametros.veiculoId) {
            showAlertMsg('É necessário adicionar ao menos um veículo');
            return;
        }
        if (!parametros.motoristaId) {
            showAlertMsg('É necessário adicionar ao menos um condutor');
            return;
        }
                
        this.props.salvarEmissaoMdfe(parametros)
            .then(() => {
                showSuccessMsg('MDF-e salvo com sucesso!');
                this.limparCampos();
                this.props.history.push('/painel-mdfe');
            });
    }

    render() {
        const { handleSubmit, submitting, invalid } = this.props;
        const { abaAtiva } = this.state;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className='col-md-12'>
                        <Titulo texto={`${this.props.id ? (this.exibirBotaoSalvar() ? 'Edição' : 'Visualização') : 'Cadastro'} MDF-e`}
                            urlRetorno="/painel-mdfe" />
                    </div>
                    <form onSubmit={handleSubmit(this.submit)}>
                        <div className="mt-4 aba-repasse-venda">
                            <ul className="nav nav-tabs" id="tabMdfe" role="tablist">
                                <li className="nav-item">
                                    <a className={`nav-link${abaAtiva === 'EMISSAO_MDFE' ? ' active' : ''}`}
                                        role="tab"
                                        onClick={(e) => { e.preventDefault(); this.irParaAba('EMISSAO_MDFE'); }}>
                                        Emissão MDF-e
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link${abaAtiva === 'PERCURSO_MDFE' ? ' active' : ''}`}
                                        role="tab"
                                        onClick={(e) => { e.preventDefault(); this.irParaAba('PERCURSO_MDFE'); }}>
                                        Percurso
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link${abaAtiva === 'CTES_MDFE' ? ' active' : ''}`}
                                        role="tab"
                                        onClick={(e) => { e.preventDefault(); this.irParaAba('CTES_MDFE'); }}>
                                        Adicionar CT-es
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content" id="tabMdfeContent" style={{ padding: '25px 5px' }}>

                                <div className={`tab-pane fade${abaAtiva === 'EMISSAO_MDFE' ? ' show active' : ''}`} role="tabpanel">
                                    <FormCadastroEmissaoMdfe
                                        dataEmissao={this.state.dataEmissao}
                                        exibirCampoBusca={this.exibirCampoBusca.bind(this)}
                                        handleSelecionarVeiculo={this.handleSelecionarVeiculo.bind(this)}
                                        handleAdicionarVeiculo={this.handleAdicionarVeiculo.bind(this)}
                                        handleRemoverVeiculo={this.handleRemoverVeiculo.bind(this)}
                                        veiculosSelecionados={this.state.veiculosSelecionados}
                                        handleSelecionarMotorista={this.handleSelecionarMotorista.bind(this)}
                                        handleAdicionarCondutor={this.handleAdicionarCondutor.bind(this)}
                                        handleRemoverCondutor={this.handleRemoverCondutor.bind(this)}
                                        condutoresSelecionados={this.state.condutoresSelecionados}
                                        handleSelecionarSeguro={this.handleSelecionarSeguro.bind(this)}
                                        somenteLeitura={this.somenteLeitura.bind(this)}
                                    />
                                </div>

                                <div className={`tab-pane fade${abaAtiva === 'PERCURSO_MDFE' ? ' show active' : ''}`} role="tabpanel">
                                    <FormCadastroPercursoMdfe
                                        percursoMdfe={this.state.percursoMdfe}
                                        removerPercursoMdfe={this.removerPercursoMdfe.bind(this)}
                                        exibirBotaoSalvar={this.exibirBotaoSalvar.bind(this)}
                                    />
                                </div>

                                <div className={`tab-pane fade${abaAtiva === 'CTES_MDFE' ? ' show active' : ''}`} role="tabpanel">
                                    <FormAdicionarCteMdfe
                                        ctesVinculados={this.state.ctesVinculados}
                                        handleSelecionarCte={this.handleSelecionarCte.bind(this)}
                                        adicionarCteVinculado={this.adicionarCteVinculado.bind(this)}
                                        removerCteVinculado={this.removerCteVinculado.bind(this)}
                                        exibirBotaoSalvar={this.exibirBotaoSalvar.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="vx-modal-footer" style={{ marginTop: '16px' }}>
                            <button type="button" className="vx-btn-secondary"
                                onClick={() => this.voltarAba()}>
                                <i className="material-icons">arrow_back</i>
                                Voltar
                            </button>
                            {abaAtiva !== 'CTES_MDFE' && (
                                <button type="button" className="vx-btn-primary"
                                    onClick={() => this.proximaAba()}>
                                    <i className="material-icons">arrow_forward</i>
                                    Próximo
                                </button>
                            )}
                            {abaAtiva === 'CTES_MDFE' && this.exibirBotaoSalvar() && (
                                <button type="submit" className="vx-btn-primary"
                                    disabled={invalid || submitting}>
                                    <i className="material-icons">save</i>
                                    Salvar
                                </button>
                            )}
                        </div>
                    </form>

                    <ModalCadastrarPercursoMdfe
                        percursoMdfe={this.state.percursoMdfe}
                        adicionarPercursoMdfe={this.adicionarPercursoMdfe.bind(this)}
                    />
                </div>
            </Autorizacao>
        )
    }
}

export const mapStateToProps = state => {
    const mdfe = state.emissaoMdfeSelecionada;
    return {
        initialValues: {
            numeroMdfe: mdfe.id,
            modelo: 58,
            serie: mdfe.serie,
            apolice: mdfe.apoliceSeguro,
            averbacao: mdfe.averbacaoSeguro,
            cnpjAutorizadoBaixarXml: mdfe.cnpjAutorizadoBaixarXml,
        },
        id: mdfe.id,
        emissaoMdfeSelecionada: mdfe,
        empresaSelecionada: state.empresaSelecionada,
        motoristas: state.motoristas,
        veiculos: state.opcoesFiltrosEmissoesMdfe.veiculos,
        ctesDisponiveisMdfe: state.opcoesFiltrosEmissoesMdfe.ctesDisponiveisMDFe,
        origem: state.origem,
        destino: state.destino,
        idUsuario: state.authentication.idUsuario,
        authentication: state.authentication,
    }
};

export default withRouter(connect(mapStateToProps, {
    selecionarOrigem,
    selecionarDestino,
    salvarEmissaoMdfe,
    changeFieldValue,
    buscarOpcoesFiltrosEmissoesMdfe,
    buscarUsuariosMotorista,
    selecionarEmissaoMdfe
})(reduxForm({
    form: 'formularioCadastroMdfe'
})(PainelCadastroEmissaoMdfe)));
